import {isEmpty} from 'lodash';

const initialState = {
    isFetchingDivorce :false,
    states: [],
    isFetchingStates: false,
    isUpdatingData: false,
    unableUpdate : false,
    isFetchingGetAllFormData: false,
    isFetchingPostData:false,
    
    petitionerCheck : "0",
    petitionerDetails: {
      firstName: "",
      lastName: "",
      streetAddress: "",
      city: "",
      zip: "",
      state: 6,
      telephone: 0,
      email: "",
    },
    respondentDetails: {
      firstName: "",
      lastName: "",
      streetAddress: "",
      city: "",
      zip: "",
      state: 6,
      telephone: "",
      email: "",
    },
    court: {
      courtStreetAddress: "",
      courtMailingAddress: "",
      city: "",
      zip: "",
      branchName: "",
      county: "",
      caseNumber : ""
    },
};


const ProfileInformationReducer = (state = initialState, action) => {
    switch (action.type) {
        
    case "REQUEST_PROFILE_FORM_DATA":
        return { ...state, isFetchingGetAllFormData: true };
      case "SUCCESS_PROFILE_FORM_DATA":
        return {
          ...state,
          isFetchingGetAllFormData: false,
          petitionerCheck:action.payload.data.petitionerCheck,
          petitionerDetails: {
            firstName: action.payload.data.petitionerDetails.firstName,
            lastName: action.payload.data.petitionerDetails.lastName,
            streetAddress: action.payload.data.petitionerDetails.streetAddress,
            city: action.payload.data.petitionerDetails.city,
            zip: action.payload.data.petitionerDetails.zip,
            state: isEmpty(action.payload.data.petitionerDetails.state) ? 6 :action.payload.data.petitionerDetails.state,
            telephone: action.payload.data.petitionerDetails.telephone,
            email: action.payload.data.petitionerDetails.email,
          },
          respondentDetails: {
            firstName: action.payload.data.respondentDetails.firstName,
            lastName: action.payload.data.respondentDetails.lastName,
            streetAddress: action.payload.data.respondentDetails.streetAddress,
            city: action.payload.data.respondentDetails.city,
            zip: action.payload.data.respondentDetails.zip,
            state: isEmpty(action.payload.data.respondentDetails.state) ? 6 :action.payload.data.respondentDetails.state,
            telephone: action.payload.data.respondentDetails.telephone,
            email: action.payload.data.respondentDetails.email,
          },
          court: {
            courtStreetAddress: action.payload.data.court.courtStreetAddress,
            courtMailingAddress: action.payload.data.court.courtMailingAddress,
            city: action.payload.data.court.city,
            zip: action.payload.data.court.zip,
            branchName: action.payload.data.court.branchName,
            county: action.payload.data.court.county,
            caseNumber: action.payload.data.court.caseNumber ,
          },
        };
  
      case "ERROR_PROFILE_FORM_DATA":
        return { ...state, isFetchingGetAllFormData: false };


    case "REQUEST_UPDATE_DATA":
      return { ...state,
        unableUpdate: true,
         isUpdatingData: true };
    case "SUCCESS_UPDATE_DATA":
      return {
        ...state,
        unableUpdate : false,
        isUpdatingData: false,
        petitionerCheck:action.payload.petitionerCheck,
        petitionerDetails: {
          firstName: action.payload.petitionerFirstName,
          lastName: action.payload.petitionerLastName,
          streetAddress: action.payload.petitionerAddress,
          city: action.payload.petitionerCity,
          zip: action.payload.petitionerZip,
          state: action.payload.petitionerState,
          telephone: action.payload.petitionerTelephoneNo,
          email: action.payload.petitionerEmail,
        },
        respondentDetails: {
          firstName: action.payload.spouseFirstName,
          lastName: action.payload.spouseLastName,
          streetAddress: action.payload.spouseAddress,
          city: action.payload.spouseCity,
          zip: action.payload.spouseZip,
          state: action.payload.spouseState,
          telephone: action.payload.spouseTelephoneNo,
          email: action.payload.spouseEmail,
        },
        court: {
          courtStreetAddress: action.payload.courtStreetAddress,
          courtMailingAddress: action.payload.courtMailingAddress,
          city: action.payload.courtCity,
          zip: action.payload.courtZip,
          branchName: action.payload.branchName,
          county: action.payload.county,
          caseNumber: action.payload.caseNumber,
        },
      };

    case "ERROR_UPDATE_DATA":
      return { ...state, 
        unableUpdate : true,
        isUpdatingData: false };
  


   case "REQUEST_STATES":
        return { ...state, isFetchingStates: true };
    case "SUCCESS_STATES": 
      return { ...state, states: action.payload, isFetchingStates: false };
    
    case "ERROR_STATES":
      return { ...state, isFetchingStates: false };

      
    case "SUCCESS_DIVORCE":
      return { ...state, divorceId: action.payload.divorce_id  , isFetchingDivorce: true };
      case "REQUEST_DIVORCE":
        return { ...state,  isFetchingDivorce: false };
      case "ERROR_DIVORCE":
        return { ...state, isFetchingDivorce: false };


      default:
        return state
    }
   
}
export default ProfileInformationReducer;